function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("polygon", {
  id: "Download_Icon_path",
  points: "1.99999999 -2.50000198e-08 0.589999986 1.40999998 5.17 6 0.589999986 10.59 1.99999999 12 8.00000002 6"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Download_Icon",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Download_Icon_wrapper",
  transform: "translate(-1.000000, 0.000000)"
}, React.createElement("g", {
  id: "Download_Icon_arrow_wrapper",
  transform: "translate(7.000000, 6.000000) rotate(-90.000000) translate(-7.000000, -6.000000) translate(2.000000, -1.000000)"
}, React.createElement("g", {
  id: "Download_Icon_arrow",
  transform: "translate(5.000000, 7.000000) rotate(-180.000000) translate(-5.000000, -7.000000) translate(1.000000, 1.000000)"
}, React.createElement("mask", {
  id: "Download_Icon_mask",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#Download_Icon_path"
})), React.createElement("rect", {
  id: "\\u21B3-\\uD83C\\uDFA8-Color",
  fill: "#FFFFFF",
  mask: "url(#Download_Icon_mask)",
  x: -8,
  y: -6,
  width: 24,
  height: 24
}))), React.createElement("rect", {
  id: "Download_Icon_rect",
  fill: "#FFFFFF",
  x: 1,
  y: 11,
  width: 12,
  height: 1
}), React.createElement("polygon", {
  id: "Download_Icon_polygon",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  points: "8 0 8 8.00633942 6 8.00633942 6 0"
})));

var SvgDownloadWhite = function SvgDownloadWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "download-white",
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDownloadWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/download_white.da29c586.svg";
export { ForwardRef as ReactComponent };